// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-tree-view-icon {
  padding-right: var(--theia-ui-padding);
  -webkit-font-smoothing: antialiased;
  flex-shrink: 0;
  padding-left: 6px;
  margin-left: -6px;
}

.theia-tree-view-inline-action {
  padding: 2px;
}

.theia-tree-view-description {
  color: var(--theia-descriptionForeground);
  font-size: var(--theia-ui-font-size0);
  margin-left: var(--theia-ui-padding);
}

.theia-tree-view .theia-TreeNodeContent {
  align-items: center;
  height: 100%;
}

.theia-tree-view .theia-TreeContainer .theia-TreeViewInfo {
  margin-top: 7px;
  margin-bottom: 10px;
  margin-left: 17px;
}

.theia-tree-view
  .theia-TreeNode:not(:hover):not(.theia-mod-selected)
  .theia-tree-view-inline-action {
  display: none;
}

.codicon.icon-inline {
  font-size: var(--theia-ui-font-size1);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/plugin-ext/src/main/browser/style/tree.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-tree-view-icon {\n  padding-right: var(--theia-ui-padding);\n  -webkit-font-smoothing: antialiased;\n  flex-shrink: 0;\n  padding-left: 6px;\n  margin-left: -6px;\n}\n\n.theia-tree-view-inline-action {\n  padding: 2px;\n}\n\n.theia-tree-view-description {\n  color: var(--theia-descriptionForeground);\n  font-size: var(--theia-ui-font-size0);\n  margin-left: var(--theia-ui-padding);\n}\n\n.theia-tree-view .theia-TreeNodeContent {\n  align-items: center;\n  height: 100%;\n}\n\n.theia-tree-view .theia-TreeContainer .theia-TreeViewInfo {\n  margin-top: 7px;\n  margin-bottom: 10px;\n  margin-left: 17px;\n}\n\n.theia-tree-view\n  .theia-TreeNode:not(:hover):not(.theia-mod-selected)\n  .theia-tree-view-inline-action {\n  display: none;\n}\n\n.codicon.icon-inline {\n  font-size: var(--theia-ui-font-size1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
